import { Pipe, PipeTransform } from '@angular/core';
import { UILineItemWithEditionPricing } from '../../shared/interface';
import { InventoryItemType, InventoryItemWithPricing } from '@galaxy/inventory-ui';
import { AppType } from '@vendasta/marketplace-apps';

@Pipe({ name: 'lineItemsToInventoryItems' })
export class LineItemsToInventoryItemsPipe implements PipeTransform {
  transform(items: UILineItemWithEditionPricing[]): InventoryItemWithPricing[] {
    if (!items?.length) {
      return [];
    }

    return items.map((item) => {
      let itemType: InventoryItemType = 'package';
      if (item.appType === AppType.APP_TYPE_APP) {
        itemType = 'app';
      } else if (item.appType === AppType.APP_TYPE_ADDON) {
        itemType = 'addon';
      }

      const inventoryItem: InventoryItemWithPricing = {
        type: itemType,
        itemId: item.lineItem.appKey?.appId ?? item.lineItem.packageId,
        name: item.name,
        iconUrl: item.iconUrl,
        pricing: item.lineItem,
        quantity: item.lineItem.quantity,
      };

      if (inventoryItem.type === 'app') {
        inventoryItem.edition = {
          editionId: item.lineItem.appKey?.editionId,
          name: item.editionName,
        };
      }

      return inventoryItem;
    });
  }
}
